import { render, staticRenderFns } from "./CalendarSvg.vue?vue&type=template&id=709e05cc&"
var script = {}
import style0 from "./CalendarSvg.vue?vue&type=style&index=0&id=709e05cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports